import { StateService } from "@uirouter/angularjs";
import { IOnInit } from "angular";
import { Contract } from "../../shared/models/contract";
import { ContractConfiguration } from "../../shared/models/contractConfiguration";

export class ContractDetailsViewController implements IOnInit {
  static $inject = ["environment", "$state"];
  contract!: any;
  contractMachines!: any;
  totalCost?: number;
  totalNetCost?: number;
  constructor(
    private readonly environment: { Date: Date },
    private readonly $state: StateService
  ) {}

  /*bindings*/
  contracts!: Contract<ContractConfiguration>;
  /*end bindings */
  currentConfiguration: ContractConfiguration | undefined;
  $onInit(): void {
    const costs: any[] = this.contract.Costs ?? [];
    this.totalCost = costs?.reduce((result, next) => result + next.Cost, 0);
    this.totalNetCost = costs?.reduce(
      (result, next) => result + next.NetCost,
      0
    );
    this.currentConfiguration = this.contract?.Configs?.find(
      (c: any) => c.CurrentConfiguration
    );
  }
}
